import type { FC } from 'react'

// import { selectActiveProject, useAppDispatch, useRootSelector } from '../../../../store'
import { AddingFilesAttributeModal } from './AddingFilesAttributeModal'
import { attributeItems } from './attributeItems'
import type {
  AddingFilesModalContainerPropsType as PropsType,
  FormDataAttributeType,
} from './types'
import { useAddingFiles } from './useAddingFiles'

const unknownFileName = 'Unknown file'

const AddingFilesAttributeModalContainer: FC<PropsType> = ({ treeObject, files = null }) => {
  // const dispatch = useAppDispatch()
  // const activeProject = useRootSelector(selectActiveProject)

  const { visibleModal, activeFileReady, onSave, onCancel } = useAddingFiles(
    files,
    undefined,
    (file: File, formData?: FormDataAttributeType) => {
      alert(`Аттрибут ${formData?.newAttributeObjectName} загружен`)
    },
  )

  return (
    <AddingFilesAttributeModal
      objectName={treeObject?.name}
      fileName={activeFileReady?.name ?? unknownFileName}
      attributeItems={attributeItems}
      isModalOpen={visibleModal}
      onCancel={onCancel}
      onSave={onSave}
    />
  )
}

export { AddingFilesAttributeModalContainer }
